
export const Blog = (props)=>{

  const blogs=props?.blogs;
  return(<>
  {Array.isArray(blogs)?  blogs?.map((item) => (
    <div className="blog-card">
        <div className={`blog-image-placeholder ${item?.placeholderImage ? 'image-with-blog' :''}`}><img src={item?.placeholderImage} alt="" /></div>
        <div className="blog-content">
          <h3 className="blog-heading">{item?.heading}</h3>
          <p className="blog-description">{item?.description}
          </p>
          <div className="blog-footer">
            <span className="blog-time">{item?.time? item?.time : '5'} min read</span>
            <a target='_blanck' href={item?.readMoreLink? item?.readMoreLink : '#'} className="blog-read-more">
              Read more
            </a>
          </div>
        </div>
      </div>
  )) : null}    
  </>)
}